import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <Section background="white" data-id="element-6">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-7">
        ¿Es este ebook para ti?
      </h2>

      <div className="grid gap-8 md:grid-cols-2" data-id="element-8">
        {/* For You */}
        <div className="bg-green-50/50 rounded-2xl p-8 border border-green-100" data-id="element-9">
          <h3 className="text-xl font-bold text-green-800 mb-6 flex items-center gap-2" data-id="element-10">
            <Check className="h-6 w-6" data-id="element-11" />
            Este ebook ES para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-12">
            {['Quieres mejorar tu relación sin perder tu dignidad.', 'Buscas herramientas prácticas, no terapia de años.', 'Estás dispuesta a probar una nueva forma de hablar.', "Valoras la paz mental por encima de 'ganar' discusiones."].map((item, i) => <li key={i} className="flex items-start gap-3 text-green-900" data-id="element-13">
                <Check className="h-5 w-5 flex-shrink-0 text-green-600 mt-0.5" data-id="element-14" />
                <span data-id="element-15">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-red-50/50 rounded-2xl p-8 border border-red-100" data-id="element-16">
          <h3 className="text-xl font-bold text-red-800 mb-6 flex items-center gap-2" data-id="element-17">
            <X className="h-6 w-6" data-id="element-18" />
            Este ebook NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-19">
            {['Buscas manipular o controlar a tu pareja.', 'Crees que toda la culpa es del otro y tú no necesitas cambiar nada.', 'No estás dispuesta a invertir tiempo en leer y practicar.', 'Esperas una solución mágica sin poner de tu parte.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900" data-id="element-20">
                <X className="h-5 w-5 flex-shrink-0 text-red-500 mt-0.5" data-id="element-21" />
                <span data-id="element-22">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}